import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e34ed3d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Please Confirm New Game Invitation", -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "form-item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Game Type", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Wager Network", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "AVAX" }, "Avalanche", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "BNB" }, "Binance Smart Chain", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "FTM" }, "Fantom", -1))
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Wager Amount", -1))
const _hoisted_13 = { value: "2" }
const _hoisted_14 = { value: "5" }
const _hoisted_15 = { value: "10" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Shot Time "),
  /*#__PURE__*/_createElementVNode("span", null, "(seconds)")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "30" }, "30", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "40" }, "40", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "60" }, "60", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "90" }, "90", -1))
const _hoisted_22 = [
  _hoisted_17,
  _hoisted_18,
  _hoisted_19,
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "footer-buttons" }
const _hoisted_24 = { class: "clearfix" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, " Are you sure you want to send a game invitation request to " + _toDisplayString(_ctx.inviteePlayerName) + "? ", 1),
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", null, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gameTypeSelected) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => {_ctx.getCryptoPrices();})
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGameTypes(), (gameType, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: gameType,
                  value: index
                }, _toDisplayString(gameType), 9, _hoisted_5))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.gameTypeSelected]
            ])
          ]),
          (_ctx.gameTypeSelected === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onChange: _cache[3] || (_cache[3] = ($event: any) => {_ctx.getWagerAmounts();})
              }, [
                _hoisted_6,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wagerNetworkSelected) = $event))
                }, _hoisted_10, 512), [
                  [_vModelSelect, _ctx.wagerNetworkSelected]
                ])
              ], 32))
            : _createCommentVNode("", true),
          (_ctx.wagerNetworkSelected != '' && _ctx.gameTypeSelected === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.wagerSelected) = $event))
                }, [
                  _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.cryptoValue * 2) + " " + _toDisplayString(_ctx.wagerNetworkSelected) + " (aprox $2 USD)", 1),
                  _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.cryptoValue * 5) + " " + _toDisplayString(_ctx.wagerNetworkSelected) + " (aprox $5 USD)", 1),
                  _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.cryptoValue * 10) + " " + _toDisplayString(_ctx.wagerNetworkSelected) + " (aprox $10 USD)", 1)
                ], 512), [
                  [_vModelSelect, _ctx.wagerSelected]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_16,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.shotTimeSelected) = $event))
            }, _hoisted_22, 512), [
              [_vModelSelect, _ctx.shotTimeSelected]
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            type: "button",
            class: "confirmbtn",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onConfirm()))
          }, " Confirm "),
          _createElementVNode("button", {
            type: "button",
            class: "deletebtn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onClose()))
          }, " Cancel ")
        ])
      ])
    ]),
    _: 1
  }))
}